// extracted by mini-css-extract-plugin
module.exports = {"label":"input-module--label--1qFDG","input":"input-module--input--ShZV6"};